import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react";

import { Button } from "components/ui/button";
import { Column } from "@tanstack/react-table";
import { cn } from "@/lib/utils";

interface SortableHeaderProps<TData = unknown, TValue = unknown> {
  column: Column<TData, TValue>;
  children: React.ReactNode;
  className?: string;
}

export const SortableHeader = <TData = unknown, TValue = unknown>({
  column,
  children,
  className,
}: SortableHeaderProps<TData, TValue>) => {
  const sorted = column.getIsSorted();
  return (
    <div className={className}>
      <Button
        variant="ghost"
        onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        className={cn(
          "h-auto p-0 has-[>svg]:px-0 font-medium hover:bg-transparent data-[state=open]:bg-accent",
          sorted ? "text-accent-foreground" : "",
        )}
      >
        {children}
        {sorted === "desc" ? (
          <ArrowDown className="ml-2 size-4" />
        ) : sorted === "asc" ? (
          <ArrowUp className="ml-2 size-4" />
        ) : (
          <ArrowUpDown className="ml-2 size-4" />
        )}
      </Button>
    </div>
  );
};
